import { Link } from 'react-router-dom';
import { CONTACT_EMAIL } from '../lib/siteBrand';

// Shared site footer — primary internal links (good for SEO crawl + navigation).
// `/about`, `/privacy`, `/terms`, `/updates` are real routes; the mentor directory is the
// home page (`/`). Contact has no route yet (added in the About+Contact PR) so it points
// at the support inbox for now — switch to `/contact` once that page ships.
const LINKS: { label: string; to: string; external?: boolean }[] = [
  { label: 'Shrey Aadi Mentor Hub', to: '/' },
  { label: 'Updates', to: '/updates' },
  { label: 'Question Papers', to: '/question-papers' },
  { label: 'Teaching Jobs', to: '/teaching-jobs' },
  { label: 'Success Stories', to: '/success-stories' },
  { label: 'About', to: '/about' },
  { label: 'Exam Calendar', to: '/exam-calendar' },
  { label: 'Contact', to: `mailto:${CONTACT_EMAIL}`, external: true },
  { label: 'Privacy', to: '/privacy' },
  { label: 'Terms', to: '/terms' },
];

// Tier-1 cities → their NEET landing (top-volume exam). Crawlable entry points into the
// SEO mesh; each landing's sibling links carry crawlers on to the other exams from there.
const CITY_LINKS: { label: string; slug: string }[] = [
  { label: 'Delhi', slug: 'delhi' }, { label: 'Mumbai', slug: 'mumbai' },
  { label: 'Bangalore', slug: 'bangalore' }, { label: 'Hyderabad', slug: 'hyderabad' },
  { label: 'Chennai', slug: 'chennai' }, { label: 'Pune', slug: 'pune' },
  { label: 'Kolkata', slug: 'kolkata' }, { label: 'Ahmedabad', slug: 'ahmedabad' },
];

export function SiteFooter() {
  const year = 2026;
  return (
    <footer style={{ borderTop: '1px solid #e5e7eb', background: '#fafbfc', padding: '2rem 1.5rem', marginTop: '3rem' }}>
      <div style={{ maxWidth: 980, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1.5rem', justifyContent: 'space-between', alignItems: 'center' }}>
          <nav style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem 1.25rem' }}>
            {LINKS.map((l) => (
              l.external
                ? <a key={l.label} href={l.to} style={FootLink}>{l.label}</a>
                : <Link key={l.label} to={l.to} style={FootLink}>{l.label}</Link>
            ))}
          </nav>
          <div style={{ fontSize: '0.8rem', color: '#64748b' }}>© {year} Shrey Aadi Education</div>
        </div>
        <nav style={{ display: 'flex', flexWrap: 'wrap', gap: '0.25rem 1rem', alignItems: 'baseline' }}>
          <span style={{ fontSize: '0.8rem', fontWeight: 700, color: '#64748b' }}>Find mentors by city:</span>
          {CITY_LINKS.map((c) => (
            <a key={c.slug} href={`/m/neet-mentor-in-${c.slug}`} style={{ ...FootLink, fontWeight: 500, fontSize: '0.82rem' }}>{c.label}</a>
          ))}
        </nav>
      </div>
    </footer>
  );
}

// display:inline-block + vertical padding gives each link a real ≥24px tap target on
// mobile (Lighthouse target-size audit) without changing the visible text size/spacing.
const FootLink: React.CSSProperties = {
  color: '#475569', fontSize: '0.88rem', fontWeight: 600, textDecoration: 'none',
  display: 'inline-block', padding: '0.5rem 0.25rem', margin: '-0.5rem -0.25rem',
};
